module.exports = __webpack_public_path__ + "static/media/vector2a.e56912d4.png";